'use client';
import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { HugeiconsIcon } from '@hugeicons/react';
import { DollarCircleIcon } from '@hugeicons/core-free-icons';
import NextImage from '@/features/Image';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import Preloader from '@/features/preloader/components/Preloader';

export default function TestimonialsPage() {
  const { data, isLoading } = useFetcherCSR(`/api/v2/testimonials`);
  if (isLoading) return <Preloader />;

  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Testimonials
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <main className="main about padding-bottom">
        <div className="testimonials-section">
          <div className="container">
            <div className="row g-4">
              <div className="col-12">
                <h2 className="fw-semibold mb-3">Testimonials</h2>
                {data?.data?.length > 0 ? (
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={30}
                    slidesPerView={1}
                    navigation
                    pagination={{
                      clickable: true,
                      dynamicBullets: true,
                      dynamicMainBullets: 3,
                    }}
                    // autoplay={{ delay: 5000 }}
                    // loop={true}
                    className="testimonial-swiper"
                  >
                    {data?.data?.map((review: any) => (
                      <SwiperSlide
                        key={review.id}
                        className="testimonial-slide"
                      >
                        <div className="testimonial-content d-flex flex-column align-items-center justify-content-center gap-3 text-center p-4">
                          <div className="testimonial-image p-4">
                            <NextImage
                              src={review?.images?.[0]?.url}
                              alt={review.name || 'Testimonial'}
                              width={250}
                              height={250}
                              className="slide-image"
                            />
                          </div>
                          {review?.user_name && (
                            <div className="testimonial-meta">
                              <h4>{review?.user_name}</h4>
                              {review?.comment && (
                                <p
                                  className="fs-small text-center"
                                  style={{ maxWidth: '500px' }}
                                >
                                  {review?.comment}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <p>testimonials not found</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>

      <div className="features-section section-bg padding-bottom padding-top">
        <div className="container">
          <h2 className="section-title fw-semibold  mb-3">Why Choose Us</h2>
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="feature-box p-4 bg-white rounded h-100">
                <span className="icon-us-dollar">
                  <HugeiconsIcon icon={DollarCircleIcon} size={56} />
                </span>
                <h3 className="feature-title fw-semibold my-2">Our Vision</h3>
                <p className="feature-text">
                  Bring inspiration and joy to people, everywhere, everyday.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="feature-box p-4 bg-white rounded h-100">
                <span className="icon-us-dollar">
                  <HugeiconsIcon icon={DollarCircleIcon} size={56} />
                </span>
                <h3 className="feature-title fw-semibold my-2">Our Mission</h3>
                <p className="feature-text">
                  To create a world where our consumers have access to a finely
                  curated, authentic assortment of products and services that
                  delight and elevate the human spirit.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
